import DomPurify from 'dompurify';
import * as Yup from 'yup';
import { TemplateFormTextField } from '../TemplateFormTextField';
import { TemplateFormHelperText } from '../../TemplateFormHelperText';
import { TemplateFormFieldValidationsFactory } from '../../../factories/templateFormFieldValidationFactory';
import { TemplateFormComponentMeta } from '../../../interfaces/template-form-component-meta';
import { TemplateFormTextFieldMeta } from '../interfaces/template-form-text-field-meta';

export const TextFieldMeta: TemplateFormComponentMeta<TemplateFormTextFieldMeta> = {
  component: TemplateFormTextField,
  MetadataFactory: (field, disableEdit) => ({
    dataId: `template-form-${field.name}`,
    label: DomPurify.sanitize(field.display_name || ''),
    required: field.required || false,
    placeholder: field.display_name,
    disabled: disableEdit || !!field.disabled,
    helperText: TemplateFormHelperText({ helperText: field.helper_text, fieldName: field.name }),
    type: 'string'
  }),
  ValidationSchemaFactory: field => TemplateFormFieldValidationsFactory(field, Yup.string().trim())
};

export const NumberTextFieldMeta: TemplateFormComponentMeta<TemplateFormTextFieldMeta> = {
  component: TemplateFormTextField,
  MetadataFactory: (field, disableEdit) => ({
    dataId: `template-form-${field.name}`,
    label: DomPurify.sanitize(field.display_name || ''),
    required: field.required || false,
    placeholder: field.display_name,
    disabled: disableEdit || !!field.disabled,
    disableDecimal: true,
    helperText: TemplateFormHelperText({ helperText: field.helper_text, fieldName: field.name }),
    type: 'number'
  }),
  ValidationSchemaFactory: field => TemplateFormFieldValidationsFactory(field, Yup.number())
};
